import React, { useContext, useState } from 'react';
import { Link } from "react-router-dom";
import { Navbar, Nav, Button, Dropdown } from "react-bootstrap";
import AuthContext from '../../context/AuthContext';


export default function Header(props) {
	let { userDetails, onPressLogout } = useContext(AuthContext)
	const [expanded, setExpanded] = useState(false);
	const closeMenu = () => setExpanded(false);

	return (
		<Navbar bg="steel" expand="md" fixed="top" variant="dark" expanded={expanded} onToggle={setExpanded}>
			<Navbar.Brand className='mr-4' as={Link} to="/" onClick={closeMenu}>{props.applicationName}</Navbar.Brand>
			<Navbar.Toggle aria-controls="navbar-nav-vision" />
			<Navbar.Collapse id="navbar-nav-vision">
				{userDetails?.is_authenticated ? (
					<>
						<Nav className="me-auto">

							{/* Doctor Access */}
							{(userDetails.user_type === "D" || userDetails.user_type === "M") && (
								<>
									{/* Patient Management Dropdown */}
									{userDetails.is_clinic_plan_expired === false && (
										<>
											<Nav.Link as={Link} to="/patient/new" className="d-none d-md-block">New Patient</Nav.Link>
										</>
									)}

									{/* Patient Management Dropdown (not visible in mobile) */}
									<Dropdown className="d-none d-md-block">
										<Dropdown.Toggle id="dropdown-patient-management">
											Patient Management
										</Dropdown.Toggle>
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to="/patient-management/patient">Patient Details</Dropdown.Item>
											<Dropdown.Item as={Link} to="/patient-management/patient-prescription">Patient Prescription</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>

									<Nav.Link as={Link} to="/appointment" onClick={closeMenu}>Appointments</Nav.Link>

									{/* Billing & Invoices Dropdown (not visible in mobile) */}
									<Dropdown className="d-none d-md-block">
										<Dropdown.Toggle id="dropdown-billing-invoices">
											Billing & Invoices
										</Dropdown.Toggle>
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to="/billing/patient-invoices">Patient Invoices</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>

									{/* Communication Dropdown (not visible in mobile) */}
									{userDetails.is_clinic_plan_expired === false && (
										<Dropdown className="d-none d-md-block">
											<Dropdown.Toggle id="dropdown-communication">
												Communication
											</Dropdown.Toggle>
											<Dropdown.Menu>
												{userDetails.plan_type === "P" && (
													<Dropdown drop="end">
														<Dropdown.Toggle as="div" className="dropdown-item">
															SMS Campaign
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<>
																<Dropdown.Item as={Link} to="/communication/sms-campaign/create">
																	Create Campaign
																</Dropdown.Item>
															</>
															<Dropdown.Item as={Link} to="/communication/sms-campaign/list">
																View Past Campaigns
															</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
												)}
												<Dropdown.Item as={Link} to="/communication/communication-notifications">Notifications Settings</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									)}

									{/* Analytics & Reports Dropdown (not visible in mobile) */}
									<Dropdown className="d-none d-md-block">
										<Dropdown.Toggle id="dropdown-analytics">
											Analytics & Reports
										</Dropdown.Toggle>
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to="/analytics-reports/patient-analytics">Patient Visit Analytics</Dropdown.Item>
											<Dropdown.Item as={Link} to="/analytics-reports/diagnosis-dashboard">Diagnosis Dashboard</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								</>
							)}

							{/* Front desk access */}
							{userDetails.user_type === "F" && (
								<>
									<Nav.Link as={Link} to="/appointment" onClick={closeMenu}>Appointments</Nav.Link>

									{/* Patient Management Dropdown (not visible in mobile) */}
									<Dropdown className="d-none d-md-block">
										<Dropdown.Toggle id="dropdown-patient-management">
											Patient Management
										</Dropdown.Toggle>
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to="/patient-management/patient-prescription">Patient Prescription</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>

									{/* Billing & Invoices Dropdown (not visible in mobile) */}
									<Dropdown className="d-none d-md-block">
										<Dropdown.Toggle id="dropdown-billing-invoices">
											Billing & Invoices
										</Dropdown.Toggle>
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to="/billing/patient-invoices">Invoice List</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>

									{/* Communication Dropdown (not visible in mobile) */}
									{userDetails.is_clinic_plan_expired === false && (
										<>
											{userDetails.plan_type === "P" && (
												<Dropdown className="d-none d-md-block">
													<Dropdown.Toggle id="dropdown-communication">
														Communication
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Dropdown drop="end">
															<Dropdown.Toggle as="div" className="dropdown-item">
																SMS Campaign
															</Dropdown.Toggle>
															<Dropdown.Menu>
																<>
																	<Dropdown.Item as={Link} to="/communication/sms-campaign/create">
																		Create Campaign
																	</Dropdown.Item>
																</>
																<Dropdown.Item as={Link} to="/communication/sms-campaign/list">
																	View Past Campaigns
																</Dropdown.Item>
															</Dropdown.Menu>
														</Dropdown>
													</Dropdown.Menu>
												</Dropdown>
											)}
										</>
									)}
								</>
							)}
						</Nav>
						<Nav className="ml-auto">
							<Nav.Link as={Link} to='#' onClick={closeMenu}>{userDetails.user_name}</Nav.Link>
							<Nav.Link as={Button} to="#" onClick={onPressLogout}>Logout</Nav.Link>
						</Nav>
					</>
				) : (<> </>)}

			</Navbar.Collapse>
		</Navbar>
	);
}
